import React from 'react';
import SMClickOutsideObserver from 'lib/SMClickOutsideObserver';
import SMConst from 'lib/SMConst';
import SMTrackHelper from 'components/helpers/SMTrackHelper';

class SMDropDownButton extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      title: this.props.title,
      link: this.props.link,
      subMenuItems: this.props.subMenuItems,
      menuDisplay: SMConst.Display.Hidden,
    };
  }
  
  componentDidMount() {
    this.clickOutsideObserver = new SMClickOutsideObserver(this);
    this.clickOutsideObserver.attach(this.hideMenu.bind(this));
    $(document).on("SMHideBaloon", this.hideMenu.bind(this));
  }
  
  componentWillUnmount() {
    this.clickOutsideObserver.detach();
    $(document).off("SMHideBaloon", this.hideMenu.bind(this));
  }
  
  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
  }
  
  hideMenu(e){
    this.setState({
      menuDisplay: SMConst.Display.Hidden
    });
  }
  
  trackPageEvent(label) {
    SMTrackHelper.pageEvent(label);
  }

  menuButtonDidSelect(e){
    if(this.props.delegate && typeof this.props.delegate.menuButtonDidSelect === 'function'){
      this.props.delegate.menuButtonDidSelect(e);
    }
  }

  subMenuButtonDidSelect(e){
    e.preventDefault();
    this.setState({
      menuDisplay: (this.state.menuDisplay == SMConst.Display.Hidden) ? SMConst.Display.Visible : SMConst.Display.Hidden
    });
  }
  
  subMenuItemDidSelect(e){
    e.preventDefault();
    this.hideMenu();
    if(this.props.delegate && typeof this.props.delegate.subMenuItemDidSelectRowAtIndex === 'function'){
      var tag = $(e.currentTarget).data("tag");
      this.props.delegate.subMenuItemDidSelectRowAtIndex(tag, e);
    }
  }
  
  render() {
    let rows = [];
    for (var i = 0; i < this.state.subMenuItems.length; i++) {
      let item = this.state.subMenuItems[i];
      rows.push(
        <li key={i}>{item.link ? <a href={item.link} onClick={this.subMenuItemDidSelect.bind(this)} data-tag={i} className="link-hover-border">{item.title}</a> : item.title}</li>
      );
    }
    let menuStyle = {
      display: (this.state.menuDisplay == SMConst.Display.Hidden) ? "none" : "",
      top: 30,
      right: 0
    };
    return (
      <div style={{position:"relative"}}>
        <div className="dropdown-button-green fr">
          <a href={this.state.link} className="dropdown-button-green__button w120 room-list__buttonarea-button" onClick={this.menuButtonDidSelect.bind(this)}><i className="fa fa-cog mr5"></i>{this.state.title}</a>
          <a href="#" className="dropdown-button-green__dropdown room-list__buttonarea-button" onClick={this.subMenuButtonDidSelect.bind(this)}><i className="fa fa-caret-down"></i></a>
        </div>
        
        <div className="baloon baloon-none room-list__baloon" style={menuStyle}>
          <div className="baloon-inner">
            <ul>
              {rows}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}
export default SMDropDownButton;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/form/SMDropDownButton.jsx